<template>
    <div>
        <Preloader v-if="isLoading"></Preloader>
        <div class="page-wrapper" v-if="!isLoading">
            <TopHeader></TopHeader>
            <header class="site-header site-header__header-one site-header__inner-page ">
                <Header></Header>
            </header><!-- /.site-header -->
            <section class="inner-banner">
                
                <div class="container">
                    <ul class="list-unstyled thm-breadcrumb">
                        <li><a href="#">{{$t('home')}}</a></li>
                        <li class="active"><a href="#">{{$t('courses')}}</a></li>
                        <li class="active"><a href="#">{{$t('elementary')}}</a></li>
                    </ul><!-- /.list-unstyled -->
                    <h2 class="inner-banner__title">{{$t('listening')}}</h2><!-- /.inner-banner__title -->
                </div><!-- /.container -->
            </section><!-- /.inner-banner -->
            <section class="course-one course-page">
            
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" v-for="item in items" :key="item.title">
                            <div class="course-one__single" @click="courseDetails(item.id)" style="cursor: pointer">
                                
                                <div class="course-one__content" style="border-top: 2px solid #f1f1f1;">
                                    <a class="course-one__category" style="color: #fff;">{{$t('listening')}}</a>
                                    <!--<div class="course-one__admin">
                                        <img :src="require('../../assets/images/team-1-1.jpeg')" alt="">
                                        by <a href="teacher-details.html">Lou Guerrero</a>
                                    </div>-->
                                    <h2 class="course-one__title"><a>{{item.title}}</a></h2>
                                    
                                    <!--<div class="course-one__stars">
                                        <span class="course-one__stars-wrap">
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                        </span>
                                        <span class="course-one__count">4.8</span>
                                        <span class="course-one__stars-count">250</span>
                                    </div>-->
                                    <!--<div class="course-one__meta">
                                        <a href="course-details.html"><i class="far fa-clock"></i> 10 {{$t('hours')}}</a>
                                        <a href="course-details.html"><i class="far fa-folder-open"></i> 6 {{$t('lectures')}}</a>
                                        <a href="course-details.html">$18</a>
                                    </div> /.course-one__meta -->
                                    <a class="course-one__link" @click.stop="courseDetails(item.id)">{{$t('see')}}</a><!-- /.course-one__link -->
                                </div><!-- /.course-one__content -->
                            </div><!-- /.course-one__single -->
                        </div><!-- /.col-lg-4 -->
                    </div>
                </div><!-- /.container -->
            </section><!-- /.course-one course-page -->
            <Footer></Footer>
        </div><!-- /.page-wrapper -->
    </div>
</template>
<script>

import '../../../assets/css/style.css'
import Footer from "../../../components/footer/Footer2.vue";
import TopHeader from '../../../components/header/TopHeader.vue';
import Header from '../../../components/header/Header.vue';
import * as firebase from '@/firebase';
import Preloader from "@/components/preloader/PreLoader.vue"
export default {
    name: "Courses",
    components: {
        Footer,
        TopHeader,
        Header,
        Preloader
    },
    data() {
        return {
            items: [],
            array: [],
            isLoading: false
        }
    },
    mounted() {
        this.getBeginnerTests();
    },
     methods :{
      courseDetails(id) {
        this.$router.push({name: 'courseELDetails', params: {courseName: id }}); 
      },
      async getBeginnerTests() {
          this.items = [];
          this.isLoading = true;
          this.events = await firebase.eVideosCollection.get()
            .then((snapshot) => {
              snapshot.forEach((el) => {
                  if(el.data().id){
                    this.array.push({...el.data()})
                    
                  }
              });
            });
            this.items = this.array.sort((a,b)=> parseInt(a.title.slice(0,2)) - parseInt(b.title.slice(0,2)));
            this.isLoading = false;
        },
    }
}
</script>